import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import ReviewPending30Cfu from "./ReviewPending30Cfu";
import { REVISOR_CONTEXTS } from "const";

class ReviewPending extends Component {
  constructor(props) {
    super(props);
    this.state = {
      idUser: this.props.match.params.idUser || 0,
    };
  }

  //--- ---

  render() {
    const { idUser } = this.state;
    const { context } = this.props.match.params;

    return (
      <>
        {[
          REVISOR_CONTEXTS.ABILITAZIONE30,
          REVISOR_CONTEXTS.ABILITAZIONE60,
          REVISOR_CONTEXTS.ART13,
          REVISOR_CONTEXTS.TFAINDIRE,
        ].includes(context) && (
          <ReviewPending30Cfu idUserRevisor={idUser} context={context} />
        )}
      </>
    );
  }
}

export default withRouter(ReviewPending);
